import type { ActionHandler } from '~/hooks/actions/types';
import { addToQueueAction } from './add-to-queue';
import { addAllToQueueAction } from './add-all-to-queue';

export type QueueActionRegistration = {
  register: (type: string, handler: ActionHandler) => () => void;
};

/**
 * Registers queue domain action handlers (`addToQueue`, `addAllToQueue`).
 *
 * @param registration - Object providing the `register` function.
 * @returns An unregister function that cleans up both handlers.
 */
export function registerQueueActions({
  register,
}: QueueActionRegistration): () => void {
  const unregisterAddToQueue = register('addToQueue', addToQueueAction);
  const unregisterAddAllToQueue = register(
    'addAllToQueue',
    addAllToQueueAction
  );

  return () => {
    unregisterAddToQueue();
    unregisterAddAllToQueue();
  };
}
